import PropTypes from 'prop-types';

// material-ui
import { FormHelperText } from '@mui/material';

// ==============================|| FORM FIELD ERROR  ||============================== //

export const FormFieldError = ({ touched, errors }) => {
  if (touched && errors) {
    return (
      <FormHelperText error id="standard-weight-helper-text">
        {errors}
      </FormHelperText>
    );
  }
  return null;
};

FormFieldError.propTypes = {
  touched: PropTypes.bool,
  errors: PropTypes.string,
};

